import { difference, isEmpty, isNil, pluck } from '../../utils/fp';
import valueTreeParser from './valueTreeParser';
import { sortByOrderAndLabel } from '../../utils/sort';
import { search, getFacetDimensionId } from '../settings';

const fillTree = valueParser => values => {
  const missingKeys = difference(pluck('parentId', values), pluck('id', values)).filter(
    key => !isNil(key),
  );
  if (isEmpty(missingKeys)) return values;
  const missingValues = missingKeys.map(val => valueParser({ val }));
  return fillTree(valueParser)([...values, ...missingValues]);
};

const rejectExcludedValuesFromDimensionFacet =
  ({ excludedFacetIds = [] }) =>
  values => {
    return values.filter(v => !excludedFacetIds.includes(v.label));
  };

export const prepareValues =
  ({ id, search, facetDimensionId }) =>
  values => {
    if (id === facetDimensionId) return rejectExcludedValuesFromDimensionFacet(search)(values);
    return values;
  };

export default options =>
  ([id, { buckets = [] }]) => {
    const localeId = options?.config?.localeId;
    const valueParser = valueTreeParser({ facetId: id, ...options });
    const rawValues = fillTree(valueParser)(buckets.map(valueParser));
    const values = prepareValues({
      id,
      search,
      facetDimensionId: getFacetDimensionId(localeId),
    })(rawValues);

    return {
      id,
      label: id,
      values: sortByOrderAndLabel(localeId)(values),
      count: values.filter(value => value.isSelected === true).length,
      hasPath: true, // if values are hierarchical and values path are computed by the parser
    };
  };
